export enum PaymentsIdentityDocumentIdentifier {
  Front = 'front',
  Back = 'back',
}

export enum Status {
  Unverified = 'unverified',
  Verifying = 'verifying',
  Verified = 'verified',
  VerificationFailed = 'verification_failed',
  VerificationBlocked = 'verification_blocked',
}

export enum ActionButtonTypes {
  Submit = 'submit',
  Continue = 'continue',
}

export enum AccountType {
  Personal = 'personal',
  Business = 'business',
}

export enum DocumentGroup {
  IdentityDocuments = 'identity_documents',
  SupportingDocuments = 'supporting_documents',
}
